import authService from "../../components/Auth/AuthorizeService";
import { ILocale } from "../../types/ILocale";

export class BaseService {

  protected transformOptions = async (options: RequestInit): Promise<RequestInit> => {
    let locale: any = localStorage.getItem('locale');
    if (locale) locale = JSON.parse(locale);

    const token = await authService.getAccessToken();

    const headers: Record<string, string> = {
      ...(options.headers as Record<string, string>),
      'accept-language': locale === ILocale.fr ? ILocale.fr : ILocale.en,
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return { ...options, headers };
  };
}
